/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ContactUpload
 */
export interface ContactUpload {
    /**
     * 
     * @type {number}
     * @memberof ContactUpload
     */
    contactId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactUpload
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUpload
     */
    uploadUri?: string;
}

/**
 * Check if a given object implements the ContactUpload interface.
 */
export function instanceOfContactUpload(value: object): boolean {
    return true;
}

export function ContactUploadFromJSON(json: any): ContactUpload {
    return ContactUploadFromJSONTyped(json, false);
}

export function ContactUploadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactUpload {
    if (json == null) {
        return json;
    }
    return {
        
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'uploadUri': json['uploadUri'] == null ? undefined : json['uploadUri'],
    };
}

export function ContactUploadToJSON(value?: ContactUpload | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contactId': value['contactId'],
        'fileName': value['fileName'],
        'uploadUri': value['uploadUri'],
    };
}

